
import { mapActions } from 'vuex'
import debounce from 'lodash/debounce'
import QuantityInput from './QuantityInput'
import ProductFunctions from '~/mixins/ProductFunctions'

export default {
  components: {
    QuantityInput,
  },

  mixins: [ProductFunctions],

  props: {
    item: {
      type: Object,
      required: true,
    },

    hideEditButtons: {
      type: Boolean,
      default: false,
    },

    isAlreadyBoughtTestLicense: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      internalItem: {},
      state: 'idle',
    }
  },

  watch: {
    item(value) {
      this.internalItem = { ...value }
    },
  },

  created() {
    this.internalItem = { ...this.item }
  },

  methods: {
    ...mapActions('cart', ['load', 'checkout', 'setAmount', 'remove']),
    removeEntry() {
      this.remove({ itemId: this.item.id })
    },

    onQuantityChange(value) {
      this.debounceSetAmount(value)
      this.internalItem.amount = value
    },

    debounceSetAmount: debounce(async function (value) {
      if (this.state === 'updating') {
        return
      }

      this.state = 'updating'
      try {
        await this.setAmount({ itemId: this.item.id, amount: value })
      } catch (error) {
        this.$sentry.captureException(error)
        this.$toast.error(this.$t('error-while-updating-amount'))
      } finally {
        this.state = 'idle'
      }
    }, 400),
  },
}
